import { Redirect, useHistory } from "react-router-dom";
import { URL } from "myconstants";
import { ReactElement, useState } from "react";
import { Action, State } from "../../state/state";
import { Input } from "components/common/Input";
import { SubmitButton } from "components/common/SubmitButton";

export function Login(props: {
  dispatch: (action: Action) => void;
  state: State;
}): ReactElement {
  const dispatch = props.dispatch;
  const state = props.state;
  const history = useHistory();
  const [userName, setUserName] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [errorMsg, setErrorMsg] = useState<string>("");

  async function signIn(e: any) {
    e.preventDefault();

    if (userName.length > 0 && password.length > 0) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/users/login`,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify({
              email: userName,
              password: password,
            }),
            credentials: "include",
          }
        );

        if (response.ok) {
          const user = await response.json();
          setErrorMsg("");
          dispatch({ type: "signIn", data: { user: user } });
          history.push(URL.selectMunicipality);
        } else if (response.status >= 500) {
          setErrorMsg("Es ist ein unerwarteter Fehler aufgetreten");
        } else {
          setErrorMsg("Ungültige Logindaten");
        }
      } catch (error) {
        dispatch({ type: "signOut" });
        setErrorMsg("Es ist ein unerwarteter Fehler aufgetreten");
      }
    }
  }

  if (
    state.user.user !== undefined &&
    state.selectedMunicipality !== undefined
  ) {
    return <Redirect to={URL.zoningPlanLegalCalculation} />;
  }

  if (
    state.user.user !== undefined &&
    state.selectedMunicipality === undefined
  ) {
    return <Redirect to={URL.selectMunicipality} />;
  }

  return (
    <main className="flex flex-col z-20 py-8 w-3/4 max-w-[800px] mx-auto">
      <h1 className="font-futura text-2xl text-gray-700 mb-4">
        Willkommen beim Luzerner Bauzonenanalysetool (LUBAT)
      </h1>
      <div className="leading-relaxed text-gray-600">
        <h1 className="font-bold mb-2">Was ist LUBAT?</h1>
        <p className="my-2">
          LUBAT, eine von der Dienststelle Raum und Wirtschaft entwickelte
          Web-App, bietet die Möglichkeit, Bauzonenkapazitäten auf Basis von
          Zonenplänen automatisch zu ermitteln.
        </p>
        <h1 className="font-bold mb-2">Kontext von LUBAT</h1>
        <p className="my-2">
          Die haushälterische Bodennutzung ist die Herausforderung, denen sich
          der Kanton und die Gemeinden heute angesichts der zunehmenden
          Bodenknappheit und Zersiedelung vermehrt stellen müssen. <br />
          Gemäss kantonalem Richtplan (KRP) ist für den Nachweis über die
          Bauzonenkapazitäten das LUBAT zu verwenden (Koordinationsaufgabe
          S1-5). Damit wird sichergestellt, dass kantonsweit eine einheitliche
          Berechnungsmethode angewendet wird und die Berechnungen
          gemeindeübergreifend vergleichbar sind.
        </p>
        <h1 className="font-bold mb-2">Login-Informationen</h1>
        <p className="my-2">
          LUBAT steht den Gemeinden und den von der Gemeinde beauftragten
          Ortsplanungsbüros sowie den regionalen Entwicklungsträgern (RET) und
          den von ihnen beauftragen Regionalplanern zur Verfügung. Falls Sie
          bereits ein kantonales Login besitzen (@lu.ch Adresse), können Sie
          sich damit einloggen. Für Fragen steht Ihnen die zuständige Person
          gemäss Liste{" "}
          <a
            className="text-blue-400"
            href="https://rawi.lu.ch/-/media/RAWI/Dokumente/Dienstleistungen/Raumentwicklung/rawi_orp_Gemeindeliste_mit_Zustaendigkeiten.pdf"
            target="_blank"
            rel="noreferrer"
          >
            Zuständigkeit nach Gemeinde, Stadt und regionale Entwicklungsträger
          </a>{" "}
          gerne zur Verfügung. Mit entsprechendem Nachweis kann ansonsten unter
          folgender E-Mail ein Login beantragt werden:{" "}
          <a className="text-blue-400" href="mailto:rawi@lu.ch">
            rawi@lu.ch
          </a>
          .
        </p>
      </div>
      {state.user.user === undefined && (
        <form className="mt-4" onSubmit={signIn}>
          <fieldset className="flex flex-col space-y-4 border-2 border-gray-300 rounded-md px-4 py-2 w-80">
            <legend className="text-blue-400 font-bold">Login</legend>
            <Input
              placeholder="E-Mail"
              value={userName}
              type="text"
              onChange={(e) => setUserName(e.target.value)}
            />
            <Input
              placeholder="Passwort"
              value={password}
              type="password"
              onChange={(e) => setPassword(e.target.value)}
            />
            <SubmitButton value="Anmelden" />
            {errorMsg.length > 0 && (
              <div className="text-sky-400 font-bold">{errorMsg}</div>
            )}
          </fieldset>
        </form>
      )}
    </main>
  );
}
